import {atom, useRecoilState} from "recoil";
import {Profile, User, UserLoginResult} from "../../api/user-api";
import {Company, CompanyOperator, Executor} from "../../api/data-api";
import {useCallback} from "react";

// export interface UserData {
//     user?: User,
//     profile?: Profile,
//     executor?: Executor,
//     company?: Company,
// }

export const userLoginResultData = atom<UserLoginResult | null>({
    key: 'userLoginResultData',
    default: null,
});

export const userData = atom<User | null>({
    key: 'userData',
    default: null,
});

export const profileData = atom<Profile | null>({
    key: 'profileData',
    default: null,
});

export const executorData = atom<Executor | null>({
    key: 'executorData',
    default: null,
});

export const companyData = atom<Company | null>({
    key: 'companyData',
    default: null,
});

export const companiesData = atom<Company[] | null>({
    key: 'companiesData',
    default: null,
});

export const companyOperatorsData = atom<CompanyOperator[] | null>({
    key: 'companyOperators',
    default: null,
});

export const showTfaCheck = atom<boolean>({
    key: 'showTfaCheck',
    default: false,
});

export const useCleanData = () => {
    const [, setUserLoginResultData] = useRecoilState(userLoginResultData);
    const [, setUser] = useRecoilState(userData);
    const [, setProfile] = useRecoilState(profileData);
    const [, setExecutor] = useRecoilState(executorData);
    const [, setCompany] = useRecoilState(companyData);
    const [, setCompanies] = useRecoilState(companiesData);
    const [, setCompanyOperators] = useRecoilState(companyOperatorsData);
    // const [, setTfaCheck] = useRecoilState(showTfaCheck);
    const cleanData = useCallback(() => {
        setUserLoginResultData(null);
        setUser(null);
        setProfile(null);
        setExecutor(null);
        setCompany(null);
        setCompanies(null);
        setCompanyOperators(null);
        // setTfaCheck(false);
    }, [setUserLoginResultData, setUser, setProfile, setExecutor, setCompany, setCompanies, setCompanyOperators]);
    return [cleanData];
};
